export default __webpack_public_path__ + "static/media/background-eseis.b5a86c2e.png";